import BaseControllerJackpotsPanel from './BaseControllerJackpotsPanel';

export default class ControllerJackpotPanels extends BaseControllerJackpotsPanel {
  constructor(data, displayData) {
    super(data, displayData);
    this.timeouts = [];
    this.startAnimations();
  }

  onResize(data) {
    const frame = data.isPortrait ? 1 : 2;
    if (this.currentFrameIndex === frame) return;
    this.goToFrame(frame);
    this.init();
    this.startAnimations();
    this.setTextStyles();
    this.updatePanels();
  }

  startAnimations() {
    const offset = 200;
    this.clearTimeouts();
    const timeout = setInterval(() => {
      this.panels.forEach((panel, index) => {
        const timeout = setTimeout(() => {
          panel.startAnimation();
        }, index * offset)
        this.timeouts.push(timeout)
      })
    }, 24000);
    this.timeouts.push(timeout)
  }

  clearTimeouts() {
    this.timeouts.forEach(timeout => clearTimeout(timeout))
    this.timeouts = [];
  }

  destroy() {
    this.clearTimeouts();
    super.destroy({ children: true })
  }
}
